import { useSelector } from 'react-redux'
import { truncateText } from 'app/utils/text'
import styles from './styles.module.scss'

const getDepartmentsData = ({ messagesData }) => messagesData.departments.data
const getActiveDepartment = ({ messagesData }) => messagesData.activeDepartment.data

function ReplyPreview({ children, msgRepliedOnId, languageInfo }) {
  const departmentsData = useSelector(getDepartmentsData)
  const activeDepartment = useSelector(getActiveDepartment)

  const getMessagePreviewById = (id) => {
    const currentDepartment = departmentsData.find((dp) => dp._id === activeDepartment)

    const chats = currentDepartment?.messages || []

    const msg = chats.find((msg) => msg.id === id)
    if (msg) {
      const messageType = msg.type

      if (['text', 'emoji'].includes(messageType)) return truncateText(msg?.content, 50)

      if (messageType === 'image') return languageInfo.texts.image
      if (messageType === 'audio') return languageInfo.texts.voice
      if (messageType === 'video') return languageInfo.texts.video
      if (['file', 'compress'].includes(messageType)) return languageInfo.texts.file
    }

    return '-'
  }

  const handleScrollIntoView = () => {
    const element = document.querySelector(`[data-id="${msgRepliedOnId}"]`)

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end' })

      // add animation
      // element.classList.remove("animate_replied_msg");
      // void element.offsetWidth;
      // element.classList.add("animate_replied_msg");
    }
  }

  return (
    <>
      <div dir="auto" className={styles.replied_msg_preview} onClick={handleScrollIntoView}>
        <span>{getMessagePreviewById(msgRepliedOnId)}</span>
      </div>
      {children}
    </>
  )
}

export default ReplyPreview
